import React from 'react';
import API from "../base/API";
import QuestionSections from "./view.1/QuestionSections";
import { connect } from "react-redux";
import { bindActionCreators } from 'redux'
import * as AnswersActionCreator from "../../redux/creators/answers";
import * as NotesActionCreator from "../../redux/creators/notes";
import Auth from "../auth/Auth";
import { hasPermission } from "../auth/Auth";
import { translate } from "../base/Translation";


import * as SectionActions from "../../redux/creators/form-builder/sections";
import * as GroupActions from "../../redux/creators/form-builder/groups";
import * as QuestionActions from "../../redux/creators/form-builder/questions";
import * as PossibleAnswerActions from "../../redux/creators/form-builder/possibleAnswers";


import eventManager from "../base/Events";

class Form extends Auth {

    constructor(props) {
        super(props);

        this.api = new API({
            get_form: "/form/fetch/:form?dont_skip_fake=true&test=:test",
            get_answers: "/answer/fetch/all/by/form/:form/test/:test",
            fill_form: "/form/fill/:form/:test",
            take_note: "/form/save_notes/:form/:test"
        });

        this.state = {
            form: false,
            answers: false
        };

        this.manualTrigger = false;
        this.formChanged = false;
        this.notesChanged = false;
    }

    fetchData() {

        this.manualTrigger = false;

        this.api.request({
            cache: false,
            route: "get_form",
            params: { form: this.props.id, test: this.props.test },
            success: (response) => {
                

                let groups = [];
                let questions = [];
                let possibleAnswers = [];
            
                JSON.parse(JSON.stringify(response.question_sections)).forEach(section => {
                    groups = groups.concat(section.question_groups);
                    delete section.question_groups;
                });

                groups.forEach(group => {
                    questions = questions.concat(group.questions);
                    delete group.questions;

                });

                questions.forEach(question => {
                    possibleAnswers = possibleAnswers.concat(question.question_possible_answers);
                    delete question.question_possible_answers;
                });

                this.props.setSections(response.question_sections, response.id);
                this.props.setGroups(groups, response.id);
                this.props.setQuestions(questions, response.id);
                this.props.setPossibleAnswers(possibleAnswers, response.id);

                this.props.addNotes(response, this.props.test);
                this.setState({ form: response });
            }
        });

        this.api.request({
            route: "get_answers",
            params: { form: this.props.id, test: this.props.test },
            success: (response) => {
                this.props.addAnswers(response, this.props.id);
            }
        });
    }

    componentDidUpdate(nextProps) {
        if (nextProps.id !== this.props.id || nextProps.test !== this.props.test) {
            this.fetchData();
        }
    }

    saveData(fromUnmount = false) {

        if (!hasPermission("FormFill", this.props.testObj)) {
            return;
        }

        // If manually clicked save and not changed
        if (!this.formChanged && this.manualTrigger === true) {
            alert(translate("Žiadne zmeny na uloženie v dotazníku neboli nájdené."));
            this.manualTrigger = false;
            return;
        }

        // If not changed
        if (!this.formChanged) {
            return;
        }

        // If user leaving and form is changed
        if (fromUnmount && this.formChanged) {
            //eslint-disable-next-line
            if (!confirm(translate("Chcete uložiť neuložené zmeny v dotazníku") + " " + this.state.form.name + "?")) {
                return;
            }
        }

        // If answers are missing
        if (this.checkMissingAnswers()) {
            alert(translate("Nie sú zodpovedané všetky otázky."));
        }

        this.api.request({
            route: "fill_form",
            params: { form: this.props.id, test: this.props.test },
            data: this.props.answers[this.props.id],
            created: (response) => {

                if (this.notesChanged) {
                    this.saveNotes();
                } else {
                    this.props.fetchData();
                }

                this.manualTrigger = false;
                this.formChanged = false;

                window.dispatchEvent(new Event("formSaved"));
                window.dispatchEvent(new Event("reloadLog"));
            }
        });

    }

    checkMissingAnswers() {
        let questionCount = 0;
        let answerCount = 0;
        let missing = false;

        for (let key in this.props.answers[this.props.id]) {
            let item = this.props.answers[this.props.id][key];
            answerCount++;

            if (typeof item === "object") {
                if (item.constructor === Array) {
                    if (item.length === 0) {
                        missing = true;
                        continue;
                    }
                } else {
                    if (item.other === true && (item.text === "" || item.text === null)) {
                        missing = true;
                        continue;
                    }
                }
            } else if (typeof item === "string") {
                if (item === "" || item === " ") {
                    missing = true;
                    continue;
                }
            }
        }

        if (missing) {
            return missing;
        }

        this.state.form.question_sections.forEach(section => {
            section.question_groups.forEach(group => {
                questionCount += group.questions.length;
            });
        });

        return questionCount > answerCount ? true : false;
    }

    saveNotes() {
        this.api.request({
            route: "take_note",
            params: { form: this.props.id, test: this.props.test },
            data: this.props.notes,
            created: (response) => {
                this.props.fetchData();
            }
        });
    }

    onSave() {
        this.manualTrigger = true;
        this.saveData();
    }

    componentDidMount() {
        this.fetchData();

        eventManager.addEvent("form_changed", this.handleFormChanged.bind(this));
        eventManager.addEvent("notes_changed", this.handleNotesChanged.bind(this));
    }

    componentWillUnmount() {
        this.saveData(true);

        eventManager.removeEvent("form_changed", this.handleFormChanged);
        eventManager.removeEvent("notes_changed", this.handleNotesChanged);
    }

    handleFormChanged(evt) {
        this.formChanged = true;
    }

    handleNotesChanged(evt) {
        this.notesChanged = true;
        this.formChanged = true;
    }

    render() {

        if (!this.state.form) {
            return (
                <div className="row">
                    <div className="col-xs-12 col-md-6">
                        <br />{translate("Načítava sa...")}
                        <br />{translate("Veľké dotazníky sa môžu načítavať dlhšiu dobu.")}
                    </div>
                </div>
            );
        }

        let saveButton = () => { };


        if (hasPermission("FormFill", this.props.testObj)) {
            saveButton = () => {
                return (
                    <div className="row">
                        <div className="col-xs-12 col-md-12 col-lg-12">
                            <button className="btn btn-success" onClick={this.onSave.bind(this)}>{translate("Uložiť")}</button>
                        </div>
                    </div>
                )
            }
        }

        return (
            <div className="questionnaire">
                <h1>{this.state.form.name}</h1>
                <div className="row">
                    <div className="col-xs-12 col-md-12 col-lg-12">
                        {/*<QuestionSections form={this.state.form} test={this.props.testObj} answers={this.state.answers} />*/}
                        <QuestionSections form={this.state.form.id} testObj={this.props.testObj} />
                    </div>
                </div>
                {saveButton()}
            </div>
        );
    }
}


function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        selectAnswer: AnswersActionCreator.selectAnswerAction,
        addAnswers: AnswersActionCreator.addAnswersAction,
        addNotes: NotesActionCreator.addNotesAction,

        addSection: SectionActions.addSectionAction,
        addGroup: GroupActions.addGroupAction,
        addQuestion: QuestionActions.addQuestionAction,
        addPossibleAnswer: PossibleAnswerActions.addPossibleAnswerAction,

        clearSections: SectionActions.clearSectionsAction,
        clearGroups: GroupActions.clearGroupsAction,
        clearQuestions: QuestionActions.clearQuestionsAction,
        clearPossibleAnswers: PossibleAnswerActions.clearPossibleAnswersAction,

        setSections: SectionActions.setSectionsAction,
        setGroups: GroupActions.setGroupsAction,
        setQuestions: QuestionActions.setQuestionsAction,
        setPossibleAnswers: PossibleAnswerActions.setPossibleAnswersAction,

    }, dispatch);
}

export default connect(state => ({ answers: state.answers, notes: state.notes }), matchDispatchToProps)(Form);


// WEBPACK FOOTER //
// ./src/modules/form/Form.js